import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../../css/table.css';
import { get } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import { useState } from 'react';
import { IoEye } from 'react-icons/io5';
import { Tooltip } from '@mui/material';
import SelectDropdown from '../../Common/SelectDropdown';
import { dashboardTableHeader } from '../../Fields/grievanceFields';
import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function TicketsList({
  heading,
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
  onView,
  onStepperForm,
  register,
  errors,
}) {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [searchVal, setSearchVal] = useState('');
  const headers = dashboardTableHeader;
  const { role } = useSelector((state) => state.user);

  const getRowColorClass = (row) => {
    if (!row.issueOpen) return '';
    const issueOpenDate = moment(row.issueOpen);
    if (!issueOpenDate.isValid()) return '';

    const weeksOpen = moment().diff(issueOpenDate, 'weeks');

    if (row.ticketStatus === 'resolved') {
      return 'text-green-800'; // green bg + text
    }

    if (row.ticketStatus === 'backlog' && weeksOpen > 6) {
      return 'text-red-800';
    }

    if (row.ticketStatus === 'backlog' && weeksOpen >= 3 && weeksOpen <= 6) {
      return 'text-orange-800';
    }

    return ''; // default
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const paginatedData = stableSort(
    tableRowsData,
    getComparator(order, orderBy)
  ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <React.Fragment>
      <div className="taskList shadow-lg bg-white">
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={0}
                searchVal={searchVal}
                heading={heading}
                searchBar={false}
                order={order}
                orderBy={orderBy}
                rowCount={paginatedData.length || 0}
                tableRowsData={paginatedData}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getListData}
              >
                {paginatedData &&
                  paginatedData.length > 0 &&
                  paginatedData.map((data) => (
                    <TableCard
                      key={data.ticketNo}
                      ticketNo={data.ticketNo}
                      requestTitle={data.requestTitle}
                      applicantName={data.applicantName}
                      requestType={
                        data?.requestType || data?.privateRequestType
                      }
                      referralName={data?.referralName}
                      status={data.ticketStatus}
                      onEdit={(e) => onStepperForm(data, e)}
                      onView={(e) => onStepperForm(data, e)}
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={tableRowsData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Entries per page: '}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              heading={heading}
              order={order}
              searchBar={false}
              orderBy={orderBy}
              rowCount={paginatedData.length || 0}
              tableRowsData={paginatedData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getListData}
            >
              <TableBody className="table-body">
                {paginatedData &&
                  paginatedData.length > 0 &&
                  stableSort(paginatedData, getComparator(order, orderBy)).map(
                    (row, index) => (
                      <TableRow hover tabIndex={-1} key={index}>
                        {headers.map((cell) => (
                          <TableCell
                            key={cell.id + index}
                            className={cell.id === 'sno' ? 'sno-column' : ''}
                          >
                            {cell.id === 'action' ? (
                              <div
                                className={`justify-around items-center flex ${getRowColorClass(
                                  row
                                )}`}
                              >
                                <div
                                  onClick={(e) => {
                                    if (role !== 'user') {
                                      onView(row, e);
                                    }
                                  }}
                                  style={{
                                    pointerEvents:
                                      role === 'user' ? 'none' : 'auto',
                                    opacity: role === 'user' ? 0.5 : 1,
                                  }}
                                >
                                  <IoEye size={23} />
                                </div>
                              </div>
                            ) : cell.id === 'ticketNo' ? (
                              <div
                                className={`flex cursor-pointer font-bold ${getRowColorClass(
                                  row
                                )}`}
                                style={{
                                  pointerEvents:
                                    role === 'user' ? 'none' : 'auto',
                                }}
                              >
                                <div
                                  onClick={(e) =>
                                    role !== 'user' && onStepperForm(row, e)
                                  }
                                >
                                  {get(row, cell.id)}
                                </div>
                              </div>
                            ) : cell.id === 'sno' ? (
                              index + 1
                            ) : cell.id === 'ticketStatus' ? (
                              <div
                                className={`capitalize rounded-md px-2 py-1 text-sm font-bold ${getRowColorClass(
                                  row
                                )} `}
                              >
                                {get(row, cell.id)}
                              </div>
                            ) : cell.id === 'requestType' ? (
                              <div className={`capitalize`}>
                                {get(row, 'requestType') ||
                                  get(row, 'privateRequestType')}
                              </div>
                            ) : cell.id === 'assignedTo' ? (
                              get(row, cell.id)?.split('@')[0]
                            ) : cell.id === 'requestTitle' ? (
                              (() => {
                                const fullText = get(row, cell.id) || '';
                                const capitalizeWords = (text) =>
                                  text
                                    .toLowerCase()
                                    .split(' ')
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(' ');

                                const capitalizedFullText =
                                  capitalizeWords(fullText);
                                const displayText =
                                  capitalizedFullText.length > 40
                                    ? capitalizedFullText.slice(0, 40) + '...'
                                    : capitalizedFullText;

                                return capitalizedFullText.length > 40 ? (
                                  <Tooltip title={capitalizedFullText}>
                                    <span>{displayText}</span>
                                  </Tooltip>
                                ) : (
                                  <span>{displayText}</span>
                                );
                              })()
                            ) : cell.id === 'applicantName' ? (
                              (() => {
                                const fullText = get(row, cell.id) || '';
                                const displayText =
                                  fullText.length > 15
                                    ? fullText.slice(0, 15) + '...'
                                    : fullText;

                                return fullText.length > 15 ? (
                                  <Tooltip title={fullText}>
                                    <span>{displayText}</span>
                                  </Tooltip>
                                ) : (
                                  <span>{displayText}</span>
                                );
                              })()
                            ) : cell.id === 'referralName' ? (
                              (() => {
                                const fullText = get(row, cell.id) || '';
                                const displayText =
                                  fullText.length > 15
                                    ? fullText.slice(0, 15) + '...'
                                    : fullText;

                                return fullText.length > 15 ? (
                                  <Tooltip title={fullText}>
                                    <span>{displayText}</span>
                                  </Tooltip>
                                ) : (
                                  <span>{displayText}</span>
                                );
                              })()
                            ) : (
                              get(row, cell.id)
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    )
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={tableRowsData?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={'Entries per page: '}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
